import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference, DocumentReference } from '@angular/fire/compat/firestore';
import { Customer, BlackUser } from '../models/customer.model';
import { Logger } from '../logger.service';
import { add } from 'date-fns';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { serverTimestamp } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
const log = new Logger('customer-service');

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private collection: CollectionReference<Customer>;

  constructor(private firestore: AngularFirestore, private afAuth: AngularFireAuth) {
    this.collection = this.firestore.collection<Customer>('customers').ref;
  }

  getCustomerObservable(uid: string): Observable<Customer | null> {
    return this.firestore
      .doc<Customer>(`customers/${uid}`)
      .valueChanges({ idField: 'uid' })
      .pipe(
        map((c) => c ?? null) // si c es undefined, devuelve null
      );
  }
  // Obtener todos los elementos
  async getAll(): Promise<Customer[]> {
    const snap = await this.collection.get();
    const data = snap.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  // Obtener un elemento por ID
  async getById(uid: string): Promise<Customer | null> {
    const snap = await this.collection.doc(uid).get();
    if (snap.exists) {
      const data = { uid: snap.id, ...snap.data() } as Customer;
      return data;
    } else {
      return null;
    }
  }

  // Obtener plantilla configurable de mensaje para compartir referido
  async getReferralShareTemplate(): Promise<string | null> {
    try {
      const docSnap = await this.firestore.doc<{ template?: string }>('maintenance/referralsShare').ref.get();
      if (docSnap.exists) {
        return docSnap.data()?.template || null;
      }
    } catch (e) {
      log.error('Error fetching referralShare template:', e);
    }
    return null;
  }

  // Crear un nuevo elemento
  async create(item: Customer): Promise<{
    success: boolean;
    message: string;
  }> {
    try {
      const exists = await this.getById(item.uid!);
      if (!exists) {
        this.collection;
        await this.collection.doc(item.uid!).set(item);
        return {
          success: true,
          message: 'Usuario agregado correctamente',
        };
      } else {
        return {
          success: false,
          message: 'Usuario ya existente',
        };
      }
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
      };
    }
  }

  // Actualizar un elemento
  async update(uid: string, item: Partial<Customer>): Promise<void> {
    const wen: any = {
      ...item,
      modifiedAt: serverTimestamp(),
    };
    await this.collection.doc(uid).update(wen);
  }

  // Eliminar un elemento
  async delete(uid: string): Promise<void> {
    try {
      await this.collection.doc(uid).delete();
    } catch (error) {
      log.error(error);
    }
  }

  // Eliminar usuario del auth
  async deleteCurrentAuthUser(): Promise<void> {
    const user = await this.afAuth.currentUser;
    if (user) {
      try {
        await user.delete();
      } catch (error) {}
    }
  }
  async getBlackUsers() {
    const dataFB = await this.firestore.collection<BlackUser>('blackList').get().toPromise();
    const data = dataFB?.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  async addBlackUser(uid: string, email: string, firstName: string, blackPhone: string) {
    const blackUser = {
      blackEmail: email,
      blackName: firstName,
      blackId: uid,
      blackNumber: blackPhone,
      blackNumberClean: blackPhone,
      addedAt: new Date(),
      addedByXcel: false,
    };
    await this.firestore.collection('blackList').add(blackUser);
    await this.delete(uid);
    await this.deleteCurrentAuthUser();
  }
}
